import { graphql, useStaticQuery } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IngenieOtsQuery } from 'graphql-types';
import React from 'react';
import { CardOt } from '../listingOt/cardOt/CardOt';

import * as styles from './linkedOts.module.scss';

interface ILinkedOtsProps {
  otsIds: string[];
}

export const LinkedOts = ({ otsIds }: ILinkedOtsProps) => {
  const ots = useStaticQuery<IngenieOtsQuery>(QUERY)?.allIngenieOt?.nodes;
  const otsLinked = ots.filter((ot) => otsIds.includes(ot.id));

  return (
    <div className={styles.cardWrapper}>
      <Swiper className={styles.swipperContainer} slidesPerView="auto" spaceBetween={16}>
        {otsLinked.map((ot) => (
          <SwiperSlide key={`reco-ots-${ot?.id}`} className={styles.slide}>
            <CardOt key={ot.id} ot={ot} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export const QUERY = graphql`
  query IngenieOts {
    allIngenieOt {
      nodes {
        ...cardOtFragment
        ...wishListFragment
        localisation {
          adresse {
            ville
          }
        }
        pictosPartners {
          url
          alt
        }
        ouvertures {
          date_debut
          date_fin
        }
        criteres210 {
          histoirePatrimoine
          art
          musique
          gastronomieEtVins
          sport
          nature
          soiree
          jeunePublic
          plusDeRdv
        }
      }
    }
  }
`;
